// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"two-column_alignLeft__g1u6h","alignRight":"two-column_alignRight__Ss6mn"};